"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContentPageId = void 0;
/**
 * IDs dos formulário de reconhecimento de cliente.
 */
var FormContentPageId;
(function (FormContentPageId) {
    FormContentPageId["EMBEDDED_FORM"] = "formulario_incorporavel";
    FormContentPageId["MLD_CHECKOUT_EMBEDDED_FORM"] = "formulario_incorporavel_minhaloja_checkout";
    FormContentPageId["MLD_CHECKOUT_EMBEDDED_FORM_EMAIL"] = "minhaloja_checkout_email";
    FormContentPageId["MLD_WISHLIST"] = "minhaloja_favoritos";
})(FormContentPageId = exports.FormContentPageId || (exports.FormContentPageId = {}));
